import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { LocalizationNavigationService } from '../../../../services/localization-navigation-service';

/**
 * Localization form preview component: Shows a widget preview
 */
@Component({
  selector: 'localization-form-preview',
  templateUrl: './localization-form-preview.component.html',
  styleUrls: ['./localization-form-preview.component.css']
})
export class LocalizationFormPreviewComponent {

  /**
   * Widget is displayed?
   */
  isWidgetDisplayed = false;

  /**
  * Widget data
  */
  widgetData: any;

  /**
  * Indicating if at least one label was edited
  */
  isLabelEdited = false;

  /**
   * Editing language form
   */
  editingLanguageForm: UntypedFormGroup;

  /**
   * Widget data input setter
   */
  @Input() set widget(data: any) {
    if (data) {
      this.widgetData = data;
      this.createForm();
    }
  }

  /**
   * Selected grid item isDefault flag
   */
  @Input() isDefault: boolean;

  /**
* Indicates whether ref list translate dialog is shown.
*/
  showRefListTranslateDialog = false;

  /**
* Selected field in the grid
*/
  selectedField: any;

  /**
   * Constructor
   * @param formBuilder
   * @param localizationNavigationService
   */
  constructor(private formBuilder: UntypedFormBuilder,
    private localizationNavigationService: LocalizationNavigationService) { }


  /**
   * Validates names
   * @returns
   */
  private forbiddenNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const regex = /^\w+$/;
      const forbidden = control.value != '' && !regex.test(control.value);
      return forbidden ? { forbiddenName: { value: control.value } } : null;
    };
  }

  /**
    * Create localization form
    */
  createForm(): void {
    this.editingLanguageForm = this.formBuilder.group({
      editingLanguageValues: this.formBuilder.array([]),
      hashTagNames: this.formBuilder.array([])
    });

    const editingLanguageValues = this.editingLanguageForm.get('editingLanguageValues') as UntypedFormArray;
    const hashTagNames = this.editingLanguageForm.get('hashTagNames') as UntypedFormArray;
    this.widgetData.labels.forEach((item) => {
      editingLanguageValues.push(this.formBuilder.control(item.editedLanguageValue));
      hashTagNames.push(this.formBuilder.control({ value: item.hashTagName, disabled: !this.isDefault }, [this.forbiddenNameValidator()]));
    });
  }

  /**
   * On input change action
   * @param labelIndex label index
   * @param event InputEvent object
   */
  onInputChange(labelIndex: number, event: InputEvent): void {
    const inputEl = event.target as HTMLInputElement;
    const newValue = inputEl.value;

    this.widgetData.labels[labelIndex].editedLanguageValue = newValue;
    this.localizationNavigationService.onIsTranslationUpdated(true);
  }

  /**
   * On hashtag input change action
   * @param labelIndex label index
   * @param event InputEvent object
   */
  onHashtagInputChange(labelIndex: number, event: InputEvent): void {
    const inputEl = event.target as HTMLInputElement;
    const newValue = inputEl.value;

    this.widgetData.labels[labelIndex].hashTagName = newValue;
    this.localizationNavigationService.onIsTranslationUpdated(true);
  }

  /**
   * Boolean for widget preview
   * @param event
   */
  widgetDisplay(event: any) {
    this.isWidgetDisplayed = !this.isWidgetDisplayed;
  }

  /**
   * Display dialog for supported field dropdowns
   * @param field
   */
  public displayRefListTranslateDialog(field: any) {
    this.selectedField = field;
    this.showRefListTranslateDialog = true;
  }

  /**
 * Close supported field dropdowns dialog
 */
  public closeRefListTranslateDialog() {
    this.showRefListTranslateDialog = false;
  }
}
